<sdc-bo-dialog
  headerTitle="Preview Confirmation Email"
  [styleClass]="['variant-prominent-title']">
  <div class="mt-6 content-wrapper">
    <div id="html-preview">
      <div [innerHTML]="templateHtml"></div>
    </div>
  </div>

  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="primary" (onClick)="onClose()"> Close </sdc-button>
  </ng-container>
</sdc-bo-dialog>
